import { takeLatest, takeEvery, put, call, cancelled } from 'redux-saga/effects';
import { normalize } from 'normalizr';

import {
  order as orderSchema,
  orders as ordersSchema,
} from '../schema/order';

import {
  REQUEST_ORDER_START,
  PLACE_ORDER_NATIONAL_START,
  PLACE_ORDER_FOREIGN_START,
  UPDATE_INVESTIGATION_CODES_START,
  COMPLETE_ORDER_START,
  REOPEN_ORDER_START,
  REQUEST_ORDERED_COMPANIES_OVERVIEW_START,
} from '../actions';

angular.module('tct.sagas.orders', [])
  .factory('ordersSagaFactory', ordersSagaFactory);

ordersSagaFactory.$inject = [
  'actionsFactory',
  'ordersService',
  'mappingService',
  '$rootScope',
];

function ordersSagaFactory(actionsFactory, ordersService, mappingService, $rootScope) {
  const factory = {
    ordersFlow,
  };

  function* getOrders(action) {
    try {
      const response = yield call(ordersService.getOrders, action.listType, action.params);
      const pagination = mappingService.objectKeysToCamel(response.data && response.data.data);
      yield put(actionsFactory.reqOrdersSuccess({
        response: normalize(pagination.items, ordersSchema),
        total: pagination.totalItems,
      }, action.listType));
    } catch (err) {
      yield put(actionsFactory.reqOrdersError(err));
    } finally {
      if (yield cancelled()) {
        console.log('cancelled');
      }
    }

    return 'done';
  }

  function* placeOrderNational(action) {
    try {
      const response = yield call(ordersService.placeOrderNational, action.order);
      yield put(actionsFactory.placeOrderNationalSuccess({
        response: normalize(
          mappingService.objectKeysToCamel(response.data && response.data.data),
          orderSchema),
      }));
      yield put(actionsFactory.state('authenticated.orders'));
    } catch (err) {
      yield put(actionsFactory.placeOrderNationalError(err));
    } finally {
      if (yield cancelled()) {
        console.log('cancelled');
      }
    }
  }

  function* placeOrderForeign(action) {
    try {
      const response = yield call(ordersService.placeOrderForeign, action.order);
      yield put(actionsFactory.placeOrderForeignSuccess({
        response: normalize(
          mappingService.objectKeysToCamel(response.data && response.data.data),
          orderSchema),
      }));
      yield put(actionsFactory.state('authenticated.orders'));
    } catch (err) {
      yield put(actionsFactory.placeOrderForeignError(err));
    } finally {
      if (yield cancelled()) {
        console.log('cancelled');
      }
    }
  }

  function* completeOrder(action) {
    try {
      const response = yield call(ordersService.completeOrder, action.orderId, action.message);
      yield put(actionsFactory.completeOrderSuccess(
        normalize(
          mappingService.objectKeysToCamel((response.data && response.data.data) || {}),
          orderSchema)));
      $rootScope.$broadcast('order-marked-completed');
    } catch (err) {
      yield actionsFactory.completeOrderError(err);
    } finally {
      if (yield cancelled()) {
        console.log('cancelled');
      }
    }
  }

  function* reopenOrder(action) {
    try {
      const response = yield call(ordersService.reopenOrder, action.orderId, action.message);
      yield put(actionsFactory.reopenOrderSuccess(
        normalize(
          mappingService.objectKeysToCamel((response.data && response.data.data) || {}),
          orderSchema)));
      $rootScope.$broadcast('order-marked-reopened');
    } catch (err) {
      yield actionsFactory.reopenOrderError(err);
    } finally {
      if (yield cancelled()) {
        console.log('cancelled');
      }
    }
  }

  function* getOrderedCompaniesOverview(action) {
    try {
      const response = yield call(ordersService.getOrderedCompaniesOverview, action.params);
      const pagination = mappingService.objectKeysToCamel(
        (response.data && response.data.data) || {});
      yield put(actionsFactory.requestOrderedCompaniesOverviewSuccess(pagination));
    } catch (err) {
      yield actionsFactory.requestOrderedCompaniesOverviewError(err);
    } finally {
      if (yield cancelled()) {
        console.log('cancelled');
      }
    }
  }

  function* updateInvestigationCodes(action) {
    try {
      const response = yield call(
        ordersService.updateInvestigationCodes,
        action.orderId, action.investigation,
      );
      yield put(actionsFactory.updateInvestigationCodesSuccess({
        response: normalize(
          mappingService.objectKeysToCamel(response.data && response.data.data),
          orderSchema),
      }));
      yield put(actionsFactory.state());
    } catch (err) {
      yield actionsFactory.updateInvestigationCodesError(err);
    } finally {
      if (yield cancelled()) {
        console.log('cancelled');
      }
    }
  }

  function* ordersFlow() {
    yield takeEvery(REQUEST_ORDER_START, getOrders);
    yield takeLatest(PLACE_ORDER_NATIONAL_START, placeOrderNational);
    yield takeLatest(PLACE_ORDER_FOREIGN_START, placeOrderForeign);
    yield takeLatest(UPDATE_INVESTIGATION_CODES_START, updateInvestigationCodes);
    yield takeLatest(COMPLETE_ORDER_START, completeOrder);
    yield takeLatest(REOPEN_ORDER_START, reopenOrder);
    yield takeLatest(REQUEST_ORDERED_COMPANIES_OVERVIEW_START, getOrderedCompaniesOverview);
  }

  return factory;
}
